import { render } from "./FacetsSbi.vue?vue&type=template&id=3c91df6f"
import script from "./FacetsSbi.vue?vue&type=script&lang=js"
export * from "./FacetsSbi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__